import config from '../../config.json';
import { asyncMemoize, logError } from '../../utils/utils';
const fetch = require('node-fetch')
const https = require('https')

const [wrapperFetchStatesOfIndia] = asyncMemoize(async () => {
  try {
    const resp = await fetch(`${config.apiSetu}/v2/admin/location/states`);
    const { states = [] } = await resp.json();
    states.sort((a, b) => a.state_name > b.state_name)
    return new Promise((resolve) => {
      resolve({ states, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
});
export const fetchStatesOfIndia = wrapperFetchStatesOfIndia

const [wrappedFetchDistrictsOfIndia] = asyncMemoize(async (params) => {
  try {
    const { stateId } = params;
    const resp = await fetch(`${config.apiSetu}/v2/admin/location/districts/${stateId}`);
    const { districts = [] } = await resp.json();
    districts.sort((a, b) => a.district_name > b.district_name)
    return new Promise((resolve) => {
      resolve({ districts, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
});

export const fetchDistrictsOfIndia = wrappedFetchDistrictsOfIndia

export const fetchSessionUsingPinCode = async (params) => {
  try {
    const { pinCode, date } = params;
    const resp = await fetch(`${config.apiSetu}/v2/appointment/sessions/public/findByPin?pincode=${pinCode}&date=${date}`); // FORMAT 26-05-2021
    const sessions = await resp.json();
    return new Promise((resolve) => {
      resolve({ ...sessions, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};

export const fetchSessionUsingDistrict = async (params) => {
  try {
    const { districtId, date } = params;
    const resp =
      await fetch(`${config.apiSetu}/v2/appointment/sessions/public/findByDistrict?district_id=${districtId}&date=${date}`); // FORMAT 26-05-2021
    const sessions = await resp.json();
    return new Promise((resolve) => {
      resolve({ ...sessions, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};

export const fetchSessionsCalenderByPin = async (params) => {
  try {
    const { pinCode, date } = params;
    const resp =
      await fetch(`${config.apiSetu}/v2/appointment/sessions/public/calendarByPin?pincode=${pinCode}&date=${date}`); // FORMAT 26-05-2021
    const sessions = await resp.json();
    return new Promise((resolve) => {
      resolve({ ...sessions, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};

export const fetchSessionsCalenderByDistrict = async (params) => {
  try {
    const { districtId, date } = params;
    const resp =
      await fetch(`${config.apiSetu}/v2/appointment/sessions/public/calendarByDistrict?district_id=${districtId}&date=${date}`); // FORMAT 26-05-2021
    const sessions = await resp.json();
    return new Promise((resolve) => {
      resolve({ ...sessions, apiResponseCode: 'success' });
    });
  } catch (error) {
    logError(error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};

export const getBanners = async () => {
  let response = {}
  try {
    const httpsAgent = new https.Agent({
      rejectUnauthorized: true
    })
    response = await fetch(config.vaccine_slot_finder_configuration_url, {
      method: 'GET',
      agent: httpsAgent,
      timeout: 3000
    })
    response = await response.json()
    return new Promise((resolve, reject) => {
      resolve(response)
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      reject(e)
    })
  }
}


